(() => {
  'use strict';

  const stylesheetUrl = document.currentScript?.dataset.cistaFormsCss;
  const initialized = Symbol.for('cista.forms.theme');
  if (!stylesheetUrl || window[initialized] || !window.MutationObserver) return;
  window[initialized] = true;

  const popupSelector = 'shopify-forms-embed[id^="app-embed-container-"]';
  const stylesheetSelector = 'link[data-cista-forms-theme]';
  const observers = new Map();

  function observePopup(host) {
    if (!host.isConnected || observers.has(host) || !host.shadowRoot) return;
    const root = host.shadowRoot;

    function ensureStylesheet() {
      // Wait for Shopify's own content. Never create or replace a form.
      if (!root.querySelector('[data-form-root]') || root.querySelector(stylesheetSelector)) return;
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = stylesheetUrl;
      stylesheet.dataset.cistaFormsTheme = '';
      root.append(stylesheet);
    }

    const observer = new MutationObserver(ensureStylesheet);
    observers.set(host, observer);
    observer.observe(root, { childList: true, subtree: true });
    ensureStylesheet();
  }

  function scan(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(popupSelector)) observePopup(node);
    node.querySelectorAll(popupSelector).forEach(observePopup);
  }

  const documentObserver = new MutationObserver((records) => {
    observers.forEach((observer, host) => {
      if (host.isConnected) return;
      observer.disconnect();
      observers.delete(host);
    });
    records.forEach((record) => record.addedNodes.forEach(scan));
  });

  documentObserver.observe(document.documentElement, { childList: true, subtree: true });
  scan(document.documentElement);

  // Existing custom elements can gain their open root after the app loads.
  window.customElements?.whenDefined('shopify-forms-embed').then(() => {
    scan(document.documentElement);
  });
})();
